// extracted by mini-css-extract-plugin
export default {"container":"CreateMenu_container__s6qXz","item":"CreateMenu_item__Mos0E","icon":"CreateMenu_icon__3NDKs"};